var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Navbar', {
    attrs: {
      "nav-light": true
    }
  }), _c('section', {
    staticClass: "bg-half bg-primary d-table w-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('div', {
    staticClass: "page-next-level"
  }, [_c('h4', {
    staticClass: "title text-white",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" " + _vm._s(_vm.organizationType) + " ")])])])])])]), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container card bg-light job-box rounded shadow border-0 overflow-hidden"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm.organizations == null ? _c('div', {
    staticClass: "text-center"
  }, [_c('h5', {
    staticClass: "p-5"
  }, [_vm._v(_vm._s(_vm.$t("org.no-organizations")))])]) : _vm._e(), _vm.organizations ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("index")))]), _c('th', [_vm._v(_vm._s(_vm.$t("org.partner-code")))]), _c('th', [_vm._v(_vm._s(_vm.$t("name")))]), _c('th', [_vm._v(_vm._s(_vm.$t("shortname")))]), _c('th', [_vm._v(_vm._s(_vm.$t("org.partner-type")))]), _c('th', [_vm._v(_vm._s(_vm.$t("status")))]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(" " + _vm._s(_vm.$t("action")))])])]), _c('tbody', [_vm.organizations.length == 0 ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('h5', {
    staticClass: "p-5"
  }, [_vm._v(_vm._s(_vm.$t("no-records")))])])]) : _vm._e(), _vm._l(_vm.organizations, function (organization, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index))]), _c('td', [_vm._v(_vm._s(organization.code))]), _c('td', [_vm._v(_vm._s(organization.name))]), _c('td', [_vm._v(_vm._s(organization.short_name))]), _c('td', [_vm._v(_vm._s(organization.type))]), _c('td', [organization.status == 1 ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(_vm.$t("active")))]) : _vm._e(), organization.status == 0 ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v(_vm._s(_vm.$t("inactive")))]) : _vm._e()]), _c('td', {
      staticClass: "text-right"
    }, [_vm.organizationType == 'Individu' ? _c('div', [_c('router-link', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "to": {
          name: 'organization.info-individual',
          params: {
            organization_id: organization.id
          }
        },
        "tag": "button"
      }
    }, [_c('img', {
      attrs: {
        "src": "/images/icon/view.svg",
        "height": "22px",
        "alt": ""
      }
    })])], 1) : _vm._e(), _vm.organizationType != 'Individu' ? _c('div', [_c('router-link', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "to": {
          name: 'organization.info',
          params: {
            organization_id: organization.id
          }
        },
        "tag": "button"
      }
    }, [_c('img', {
      attrs: {
        "src": "/images/icon/view.svg",
        "height": "22px",
        "alt": ""
      }
    })])], 1) : _vm._e()])]);
  })], 2)])]) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm.organizationType != 'awaris' ? _c('div', {
    staticClass: "text-center mb-5"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "to": {
        name: 'organization.create',
        query: {
          type: _vm.organizationType
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("add")) + " " + _vm._s(_vm.organizationType))])], 1) : _vm._e()])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.pagination.totalRows,
      "per-page": _vm.pagination.perPage,
      "aria-controls": "my-table"
    },
    on: {
      "change": _vm.pageClicks
    },
    model: {
      value: _vm.pagination.currentPage,
      callback: function ($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v);
      },
      expression: "pagination.currentPage"
    }
  })], 1), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form custom-form"
  }, [_c('div', {
    staticClass: "form-group mb-0"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pagination.perPage,
      expression: "pagination.perPage"
    }],
    staticClass: "form-control custom-select",
    attrs: {
      "id": "Sortbylist-job"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.pagination, "perPage", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        return _vm.changePerPage();
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 " + _vm._s(_vm.$t("per-page")))]), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25 " + _vm._s(_vm.$t("per-page")))]), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50 " + _vm._s(_vm.$t("per-page")))])])])])])])])])]), _c('Footer'), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: '#topnav',
      expression: "'#topnav'"
    }],
    staticClass: "btn btn-icon btn-soft-primary back-to-top",
    attrs: {
      "href": "javascript: void(0);",
      "id": "back-to-top"
    }
  }, [_c('arrow-up-icon', {
    staticClass: "icons"
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }